<section #coverLanding>
  <app-cover-landing />
</section>

<!-- <section #whyWorks>
  <app-why-works />
</section> -->

<section>
  <div class="container">
    <div class="title my-4 text-center">
      <h2 class="text-primary text-4xl mb-3 font-bold ">Why Exemplix?
      </h2>
      <h3 class="text-2xl my-2">Your Complete Learning Companion
      </h3>
      <p class="text-xl text-primary mt-6"> Exemplix brings high-quality notes, exam-style questions, flashcards, and
        past
        papers
        together in one smart, easy-to-use platform. Designed to help each student study confidently
        and achieve higher grades.</p>
    </div>
    <div class="container mx-auto px-4 py-8">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
        @for (feature of features; track feature.title) {
        <div
          class="bg-white rounded-lg shadow-sm hover:shadow-lg transition-shadow duration-300 p-6 border border-gray-100">
          <div class="flex gap-4">
            <!-- Icon Container -->
            <div class="flex-shrink-0 w-[25%]">
              <div class="w-24 h-24 rounded-full  flex items-center justify-center bg-primary">
                <!-- <i [class]="feature.icon + ' text-purple-600 text-2xl lg:text-3xl'"></i> -->
                <img [src]="feature.icon" class="w-16">
              </div>
            </div>

            <!-- Content Container -->
            <div class="flex-1 w-[75%]">
              <h3 class="text-lg lg:text-xl font-bold text-purple-900 mb-3">
                {{ feature.title }}
              </h3>
              <p class="text-gray-600 text-sm lg:text-base leading-relaxed">
                <span [innerHTML]="formatDescription(feature.description, feature.highlightText)"></span>
              </p>
            </div>
          </div>
        </div>
        }
      </div>
    </div>

    <!-- <img src="exam.png" alt="">
        <img src="paper.png" alt="">
    <img src="tools (1).png" alt="">
    <img src="tools.png" alt=""> -->

  </div>
</section>

<section #freeLevels>
  <app-free-levels [loading]="isLoading()" [levels]="landingData()?.data?.curriclums" />
</section>

<section #teamSection>
  <app-team-section />
</section>

<section #subjectSection>
  @defer (hydrate on viewport) {
  <app-subject-section [loading]="isLoading()" [subjects]="landingData()?.data?.subjects" />
  }
</section>

<!-- <section #popularCourses>
  <app-popular-courses 
  [courses]="landingData().data.popular_topics" />
</section> -->

<section #favMembers>
  @defer (hydrate on viewport) {
  <app-fav-members />
  }
</section>